import React from 'react';
import Type from 'prop-types';
import { Dialog, DialogContent } from "@mui/material";
import { useTranslation } from 'hooks';
import { SAVE } from 'constants/actions';
import AppBar from '../../AppBar';
import Transition from '../../Transition';
import { actions } from './FormDialog.mock';

const FormDialog = (props) => {
  const {
    title,
    open,
    onClose,
    children,
    onSave,
    hideDefaultButtons,
    isModalMode,
    fullWidth,
  } = props;
  const { t } = useTranslation();

  const handleActionItemSelected = (action) => {
    switch (action) {
      case SAVE:
        onSave();
        break;
      default:
        break;
    }
  };

  const renderAppBar = () => {
    return (
      <AppBar
        title={title}
        navIcon="close"
        actions={hideDefaultButtons ? [] : actions}
        navButtonAriaLabel={t('close')}
        onNavClick={onClose}
        onActionSelected={handleActionItemSelected}
      />
    );
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      fullScreen={!isModalMode}
      fullWidth={fullWidth}
    >
      {renderAppBar()}

      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
};

FormDialog.defaultProps = {
  hideDefaultButtons: false,
  isModalMode: false,
  fullWidth: false,
};

FormDialog.propTypes = {
  title: Type.string.isRequired,
  open: Type.bool.isRequired,
  hideDefaultButtons: Type.bool,
  isModalMode: Type.bool,
  fullWidth: Type.bool,
  onClose: Type.func.isRequired,
  onSave: Type.func.isRequired,
  children: Type.node.isRequired,
};

export default FormDialog;
